/**
 *
 *
 */

export default {
    flowchart:{
        // 工具栏
        L10000: '流程编辑器',
        L10001: '撤消（Ctrl + Z）',
        L10002: '重做（Ctrl + Shift + Z）',
        L10003: '复制（Ctrl + C）',
        L10004: '粘贴（Ctrl + V）',
        L10005: '清除（Ctrl + Shift + C）',
        L10006: '放大（Ctrl + +）',
        L10007: '缩小（Ctrl + -）',
        L10008: '适应屏幕（Ctrl + 0）',
        L10009: '实际大小（Ctrl + 1）',
        L10010: '删除',
        L10011: '填充颜色',
        L10012: '线条颜色',
        L10013: '线条宽度',
        L10014: '线条样式',
        L10015: '线条类型',
        L10016: '起点',
        L10017: '终点',
        L10018: '置于顶层',
        L10019: '置于底层',
        L10020: '框选',
        L10021: '添加组',
        L10022: '解除组',
        L10023: '编辑',
        L10024: '预览',
        L10025: '全屏',
        L10026: '语言',
        L10027: 'Github',
        L10028: '反馈',
        L10029: '缩放',
        L10030: '下载',
        // 左右面板
        L10100: '基础图形',
        L10101: '配置器',
        L10102: '导航器',
        L10103: '属性',
        L10104: '样式',
        L10105: '文本',
        // 其他
        L10200: '提示',
        L10201: '确认清空画布？'
    }
}
